/****************************************************************
 * jotai state and atoms for the related components
 ***************************************************************/

import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import callApi from 'lib/callApi';
import { companyIdAtom } from 'views/state';

import { SastTab } from './types';

export const currentTabAtom = atomWithStorage(
  'sast_current_tab',
  SastTab.AccountsList,
);

export const accountsTitlesAtom = atom(async (get) => {
  const companyId = get(companyIdAtom);

  if (companyId && companyId !== -1) {
    let response: any = undefined;
    try {
      const data = {
        company_id: companyId,
      };

      response = await callApi('sast/accounts/titles/', 'GET', data);
      return response?.data;
    } catch (err) {
      let error: any = err as any;
      console.error('ERROR in accountsTitlesAtom:', error);
    }
  }
});
